export interface VersionInfo {
  version: string
  buildTime: string
  environment: string
  buildDate: Date
  isLocal: boolean
  isDev: boolean
  isProduction: boolean
  isStaging: boolean
  isTest: boolean
}

export const getVersionInfo = (): VersionInfo => {
  const buildTime = __BUILD_TIME__
  const environment = __NODE_ENV__

  return {
    version: __APP_VERSION__,
    buildTime,
    environment,
    buildDate: new Date(buildTime),
    isLocal: environment === 'localhost',
    isDev: environment === 'dev',
    isProduction: environment === 'production',
    isStaging: environment === 'staging',
    isTest: environment === 'test',
  }
}

export const getFormattedVersion = (): string => {
  const info = getVersionInfo()

  return `v${info.version}`
}

export const getFormattedBuildInfo = (): string => {
  const info = getVersionInfo()
  const date = info.buildDate.toLocaleDateString()
  const time = info.buildDate.toLocaleTimeString()

  return `Built on ${date} at ${time}`
}

export const getEnvironmentBadge = (): string => {
  const info = getVersionInfo()

  if (info.isLocal) {
    return '🏠 Local'
  }

  if (info.isDev) {
    return '🔧 Dev'
  }

  if (info.isStaging) {
    return '🔧 Staging'
  }

  if (info.isProduction) {
    return '🚀 Production'
  }

  if (info.isTest) {
    return '🧪 Test'
  }

  return `📦 ${info.environment}`
}

/**
 * Logs version information to console.
 * Called once at app startup to avoid duplicate logs from React.StrictMode.
 */
export const logVersionInfo = (): void => {
  const info = getVersionInfo()

  // eslint-disable-next-line no-console
  console.group('🔖 Application Version Info')
  // eslint-disable-next-line no-console
  console.log(`Version: ${info.version}`)
  // eslint-disable-next-line no-console
  console.log(`Environment: ${info.environment}`)
  // eslint-disable-next-line no-console
  console.log(`Build Time: ${info.buildTime}`)
  // eslint-disable-next-line no-console
  console.log(
    `Build Date: ${info.buildDate.toLocaleDateString()} ${info.buildDate.toLocaleTimeString()}`
  )
  // eslint-disable-next-line no-console
  console.groupEnd()

  // Log version in a format that's easy to find in production logs
  // eslint-disable-next-line no-console
  console.log(`[VERSION] ${info.version} | [ENV] ${info.environment} | [BUILD] ${info.buildTime}`)
}
